/**
 * Включена ли отправка продуктовых событий (`NUXT_PUBLIC_ANALYTICS_ENABLED`).
 *
 * Значение приходит из runtimeConfig, а Nuxt приводит переменные `NUXT_PUBLIC_*`
 * к типу: `=true` в .env превращается в boolean `true`, а не в строку. Строгое
 * сравнение со строкой поэтому молча не срабатывало — флаг выставлен, а аналитика
 * мертва, и заметно это только по пустым отчётам. Принимаем оба вида записи, плюс
 * `1` — им флаги задают в CI.
 */
export const isAnalyticsEnabled = (value: unknown): boolean =>
  value === true || value === 'true' || value === 1 || value === '1'
